import { useRuntimeVariables } from 'app-kit'
import React from 'react'

/** A context providing DS API-specific information */
export const DSAPIContext = React.createContext<{
  apiURL: string
}>({ apiURL: '' })

/**
 * A high-level provider which coordinates calls to DS API. In the future,
 * advanced caching/editing might be supported via this provider.
 * @param children    Children of this component
 * @constructor
 */
export const DSAPIProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const { DS_API_URL } = useRuntimeVariables()
  return (
    <DSAPIContext.Provider value={{ apiURL: DS_API_URL }}>
      {children}
    </DSAPIContext.Provider>
  )
}
